import type { Zone } from '../Zone';
import type { TimelineSlot, Widget } from '../Widget';

export enum TimelineIdentifier {
    NORMAL = 'normal',
    TIME_BASED = 'time_based',
    LINEAR = 'linear',
}

export interface ITimeline {
    /**
     * The active widget's current slot
     */
    getCurrentSlot(): TimelineSlot | null;

    /**
     * Abort Current Loop
     */
    abortLoop(): void;

    /**
     * triggered before fade out occurs
     * @param suppressTriggers - special actions to apply
     */
    nextSlot(suppressTriggers: boolean, zone: Zone): TimelineSlot | null;

    /**
     * used to look at next widget, doesn't add to internal counter
     * @todo rename to `peakNextSlot`?
     */
    peakNext(): TimelineSlot | null;

    /**
     * Sorts the provided array of widgets by `order`
     * and sets timelineWidgets to sorted array of widgets
     */
    sortWidgets(widgetArray: Widget[]): void;
}
